module.exports = __webpack_public_path__ + "img/geod_6.447d772a.jpg";